// extracted by mini-css-extract-plugin
export default {"wrap":"jF-z","articleImagesWrap":"kF-z","articleImage":"lF-z","singleImage":"mF-z"};